"use client";

import { c as _c } from "react/compiler-runtime";
import { Col, Dropdown } from "react-bootstrap";
import styles from "./LatestActivity.module.scss";
import { TypeFilter, ContractFilter } from "@/hooks/useActivityData";
interface ActivityFiltersProps {
  readonly typeFilter: TypeFilter;
  readonly selectedContract: ContractFilter;
  readonly onTypeFilterChange: (filter: TypeFilter) => void;
  readonly onContractFilterChange: (contract: ContractFilter) => void;
  readonly isMobile: boolean;
}
export default function ActivityFilters(t0) {
  const $ = _c(20);
  const {
    typeFilter,
    selectedContract,
    onTypeFilterChange,
    onContractFilterChange,
    isMobile
  } = t0;
  const t1 = `d-flex align-items-center gap-4 ${isMobile ? "justify-content-center" : "justify-content-end"}`;
  let t2;
  if ($[0] !== selectedContract) {
    t2 = <Dropdown.Toggle>Collection: {selectedContract}</Dropdown.Toggle>;
    $[0] = selectedContract;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Object.values(ContractFilter);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onContractFilterChange) {
    t4 = <Dropdown.Menu>{t3.map(contract => <Dropdown.Item key={contract} onClick={() => onContractFilterChange(contract)}>{contract}</Dropdown.Item>)}</Dropdown.Menu>;
    $[3] = onContractFilterChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <Dropdown className={styles.filterDropdown} drop="down-centered">{t2}{t4}</Dropdown>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== typeFilter) {
    t6 = <Dropdown.Toggle>Filter: {typeFilter}</Dropdown.Toggle>;
    $[8] = typeFilter;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = Object.values(TypeFilter);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onTypeFilterChange) {
    t8 = <Dropdown.Menu>{t7.map(filter => <Dropdown.Item key={filter} onClick={() => onTypeFilterChange(filter)}>{filter}</Dropdown.Item>)}</Dropdown.Menu>;
    $[11] = onTypeFilterChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <Dropdown className={styles.filterDropdown} drop="down-centered">{t6}{t8}</Dropdown>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t5 || $[18] !== t9) {
    t10 = <Col sm={12} md={6} className={t1}>{t5}{t9}</Col>;
    $[16] = t1;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}